export default {
  philter: "versioning-dropdown",
  selected: "(selected)",
  transferRankHistory: "transfer rank history",
  versions: "versions"
};
